import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    bankAccounts: state.bankAccounts,
    // transactions: state.transactions,
    categories: state.categories,
    creditCards: state.creditCards,
    // invoices: state.invoices,
    perfil: state.perfil,
    actionPlans: state.actionPlans,
    lastActionPlanCheck: state.lastActionPlanCheck,
    banksAndCodes: state.banksAndCodes,
  })
});

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [vuexLocalStorage.plugin]
});
